import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, ImageDataLike, getImage } from "gatsby-plugin-image";

import { Box, Heading, Section, Stack, Text } from "@vinomofo/components";

export const SupportPanel = (): JSX.Element => {
  const imageKey = Math.floor(Math.random() * 3);

  const data: {
    [key: string]: ImageDataLike;
  } = useStaticQuery(graphql`
    {
      imageOne: file(
        relativePath: { eq: "wine-clubs/customer-service-01.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      imageTwo: file(
        relativePath: { eq: "wine-clubs/customer-service-02.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      imageThree: file(
        relativePath: { eq: "wine-clubs/customer-service-03.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `);

  const randomImage = getImage(Object.values(data)[imageKey]);

  return (
    <Section backgroundColor="#111">
      <Box display={["block", "flex"]} alignItems="center">
        <Box flex="1">
          <Box py={["60px", "20px"]}>
            <Stack space={5}>
              <Heading as="h2" variant="xl" color="white">
                Still have some questions?
              </Heading>

              <Stack space={3}>
                <Text color="white" fontSize={[2, 3, 4]}>
                  Our customer service team are certified legends.
                </Text>

                <Text color="white" fontSize={[2, 3, 4]}>
                  Just give them a call on 1800 663 419 or hit up Live Chat if
                  you have questions, qualms, queries or quandaries. Remember,
                  when it comes to wine there’s no such thing as a stupid
                  question, except for can I have more? Of course you can.
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Box>
        <Box flex="1">
          <GatsbyImage image={randomImage} alt="" />
        </Box>
      </Box>
    </Section>
  );
};
